import type { JSX } from "react";

export default function MobileHeading({
  actionComponent,
  searchComponent,
  extraComponent,
}: {
  actionComponent: JSX.Element;
  searchComponent?: JSX.Element;
  //this extra component is always rendered at the top
  extraComponent?: JSX.Element;
}) {
  return (
    <div className="flex flex-col gap-y-3 lg:hidden">
      {extraComponent}
      <div className="flex">{actionComponent}</div>
      {searchComponent && (
        <div className="flex gap-x-2.5">{searchComponent}</div>
      )}
    </div>
  );
}
